import React, { PureComponent } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from "recharts";
import Teams from "../../../../../api/Teams";
import CustomLabel from "./custom-label";

class PromotionalSpend extends PureComponent {
  getColor(i) {
    const baseColors = Teams.competitiveColors();
    return baseColors[i % baseColors.length];
  }

  get dataValues() {
    let data = [];

    this.props.data.forEach(item => {
      const { team, value } = item;

      data.push({
        team,
        "Product Awareness": value * 100
      });
    });

    return data;
  }

  get margin() {
    return {
      top: 20,
      left: -20,
      right: 0,
      bottom: 0
    };
  }

  render() {
    return (
      <div className="text-center">
        <div id="chartHorizontalBarPSPhones" className="horizontalBar lmm30">
          <BarChart
            layout="vertical"
            width={220}
            height={230}
            data={this.dataValues}
            margin={this.margin}
          >
            <YAxis type="category" dataKey="team" tick={false} />
            <XAxis
              type="number"
              ticks={[0, 20, 40, 60, 80, 100]}
              interval={0}
              domain={[
                dataMin => 0,
                dataMax => (dataMax < 90 ? dataMax : dataMax * 1.2)
              ]}
              tick={{ textAnchor: "end" }}
              tickFormatter={val => val + "%"}
            />
            <Tooltip formatter={val => val + "%"} />
            <Bar
              dataKey="Product Awareness"
              barSize={18}
              stackId="a"
              minPointSize={5}
              label={
                <CustomLabel
                  prefix=""
                  precision={0}
                  suffix="%"
                  layout="vertical"
                  xOffset={15}
                />
              }
            >
              {this.dataValues.map((value, i) => (
                <Cell key={i} fill={this.getColor(i)} />
              ))}
            </Bar>
          </BarChart>
        </div>
      </div>
    );
  }
}

export default PromotionalSpend;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/promotional-spend.js